export enum PortfolioTypes {
    managed = 'managed', // actually contains wine and whiskey but is currently used as default for wine portfolio
    whiskey = 'whiskey', // falls under managed
    trading = 'trading'
    // TODO: need to add wine to portfolio types
}
